export default __webpack_public_path__ + "static/media/docDarkLogo.8778ca68.svg";